import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { merge } from 'lodash';

import { beneficiaries } from '~/routes';
import { Beneficiary } from '~/types';
import { FormDrawer } from '~/components';
import BeneficiaryForm from './BeneficiaryForm';
import { cleanupFormValues } from '~/utils';
import { useBeneficiariesEdit } from '~/hooks/beneficiaries';

interface Props {
  beneficiary: Beneficiary;
  open: boolean;
  onClose: () => void;
}

const BeneficiaryEdit: FC<Props> = (props) => {
  const { beneficiary, open, onClose } = props;

  const { mutate } = useBeneficiariesEdit({ onMutate: onClose });

  const onFinish = (values: Beneficiary) => {
    const { address, email, phoneNumber, ...rest } = beneficiary;
    mutate(cleanupFormValues(merge(values, { ...rest, ...values })));
  };

  const [t] = useTranslation('payouts');

  return (
    <FormDrawer
      name={beneficiaries}
      onFinish={onFinish}
      title={t('editBeneficiary')}
      onClose={onClose}
      visible={open}
    >
      <BeneficiaryForm name={beneficiaries} initialValues={beneficiary} edit />
    </FormDrawer>
  );
};

export default BeneficiaryEdit;
